import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Process from "./sections/Process";
import Coverage from "./sections/Coverage";
import Team from "./sections/Team";
import WhyChoose from "./sections/WhyChoose";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Story />
      <Process />
      <Coverage />
      <Team />
      <WhyChoose />
      <EstimateRequestForm />
      <Action />
      <Footer />
    </div>;
}